import { render, staticRenderFns } from "./Top-Bar.vue?vue&type=template&id=115a08b6&"
import script from "./Top-Bar.vue?vue&type=script&lang=ts&"
export * from "./Top-Bar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports